const Preview=()=>{
    return(
        <>
        <h2>hello</h2>
        </>
    )
}
export default Preview;